module.exports = __webpack_public_path__ + "static/media/nav-icon-career-conversation-inactive.4aa3a00b.svg";